import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@/helpers/api';
import UserProfileService from '@/services/UserProfileService';
import { types, actions } from './reducer';

function* submitNewPassword({ data }) {
    try {
        yield call(UserProfileService.submitNewPassword, data);
        yield put(actions.submitNewPasswordSucceeded('Password was changed successfully'));
    } catch (error) {
        yield put(actions.submitNewPasswordFailed(extractError(error)));
    }
}

function* watchSubmitNewPassword() {
    yield takeEvery(
        types.REQUEST_SUBMIT_NEW_PASSWORD,
        submitNewPassword,
    );
}

function* securitySaga() {
    yield all([
        fork(watchSubmitNewPassword),
    ]);
}

export default securitySaga;
